const MiniBox = ({style, heading, paragraph, key}) => {
    return (<div key={key} class={style}>
        <h5>{heading}</h5>
        <p>{paragraph}</p>
    </div>)
}
export default MiniBox;